import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import api from "../../utils/axios";
import useLang from "../../hooks/useLang";

type Props = {};

const CurrencyManagement = (props: Props) => {
	type Currency = {
		id: number;
		description: string;
		rate: number;
	};
	const [currencies, setCurrencies] = useState<Currency[]>([]);
	const defaultColDef = {
		sortable: true,
		filter: true,
		wrapHeaderText: true,
		resizable: true,
		filterParams: { excelMode: "windows" },
		autoSizeAllColumns: true,
	};
	const { strings } = useLang("currency");
	const tableColumns = [
		{
			field: "id",
			headerName: strings?.id,
			type: "numericColumn",
			filter: "agNumberColumnFilter",
		},
		{
			field: "description",
			headerName: strings?.description,
			editable: false,
		},
		{
			field: "rate",
			headerName: strings?.value,
			editable: true,
		},
	];
	useEffect(() => {
		(async () => await fetchCurrencies())();
	}, []);

	const fetchCurrencies = async () => {
		try {
			const response = await api.get<Currency[]>("Currency");
			if (response.status === 200) {
				setCurrencies(response.data);
			}
		} catch (error) {
			console.error("Error fetching Currencies:", error);
		}

		return [];
	};

	const updateCurrency = async (id: number, rate: number) => {
		try {
			const response = await api.post("Currency/update", {
				id,
				rate,
			});
			if (response.status === 204) {
				fetchCurrencies();
			}
		} catch (error) {
			console.error("Error updating Currency:", error);
		}
	};
	const onRowEdit = async (row: any) => {
		await updateCurrency(row.data.id, row.data.rate);
		await fetchCurrencies();
	};
	return (
		<div>
			<div className="ag-theme-alpine" style={{ height: 600 }}>
				<AgGridReact
					rowData={currencies}
					defaultColDef={defaultColDef}
					columnDefs={tableColumns}
					enterMovesDown={true}
					enterMovesDownAfterEdit={true}
					undoRedoCellEditing={true}
					undoRedoCellEditingLimit={20}
					suppressCopyRowsToClipboard={true}
					rowSelection="single"
					enableRangeSelection={true}
					editType={"fullRow"}
					onRowValueChanged={(event) => {
						onRowEdit(event);
					}}
				/>
			</div>
		</div>
	);
};

export default CurrencyManagement;
